import { DocumentTypeHandler } from "../common/commonDomain";
import { NoticeToGeneralMeeting } from "../common/commonGeneralMeetingDomain";
import {
  applyForm,
  handleEvent,
  initNewForm,
  NoticeToGeneralMeetingForm,
} from "./noticeGeneralMeetingDomain";
import { DocumentType } from "../../common/documents";

export const noticeGeneralMeetingHandler: DocumentTypeHandler<
  DocumentType.notice_general_meeting,
  NoticeToGeneralMeeting,
  NoticeToGeneralMeetingForm
> = {
  type: DocumentType.notice_general_meeting,
  initNewForm,
  initForm: (form) => form.init(),
  handleEvent,
  applyForm,
};
